// The `type` of a backend PatchValue<T> (Interfirst.Skynet.Common.Domain): a null/absent field is skipped and a
// null `value` clears the field.
export const PatchValueType = {
  DIRECT: 'Direct',
  RECALCULATED: 'Recalculated',
};
